import { createAction } from '@reduxjs/toolkit';

export const importFromFile = createAction('importer/importFromFile', (file, destination) => ({
  payload: {
    file,
    destination,
  },
}));

export const setIsImporterLoading = createAction('importer/setIsImporterLoading', (isLoading) => ({
  payload: {
    isLoading,
  },
}));

export const setImportResponse = createAction('importer/setImportResponse', (response) => ({
  payload: {
    response,
  },
}));
